var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"box"},[_c('h1',{staticClass:"title"},[_vm._v("欢迎登陆PMS系统")]),_c('h4',{staticClass:"subtitle"},[_vm._v("COPYRIGHT © 2021 Huanchu")]),_c('img',{attrs:{"width":"306","src":require("../assets/images/home.png"),"alt":""}})])])
}]

export { render, staticRenderFns }